import React, { useEffect, useState } from 'react';

import Dropdown, { DropdownItem, ComponentProps as DropdownProps } from '../../Dropdown';
import Input from '../../Input';
import TextArea from '../../TextArea';
import * as Styled from './styled';

/**
 * type to render the overseas
 */
export type RenderMode = 'Basic' | 'Full';

export type ComponentProps = {
  /**
   * field name for Formik to map location of the Address FormValues colleciton
   */
  fieldName: string;
  /**
   * type to render the overseas input
   */
  mode: 'Basic' | 'Full';
  /**
   * function that resolves with the list of countries to select from
   */
  loadCountriesHandler: () => Promise<DropdownItem[]>;
  /**
   * full text area props (basic mode) for customisation when needed
   */
  fullAddressTextAreaProps?: React.TextareaHTMLAttributes<HTMLTextAreaElement>;
  /**
   * country dropdown props for customisation when needed
   */
  countryDropDownProps?: Partial<DropdownProps>;
};

/**
 * Unique overseas address details component
 */
const Info: React.FC<ComponentProps> = ({
  fieldName,
  mode,
  loadCountriesHandler,
  fullAddressTextAreaProps,
  countryDropDownProps
}) => {
  const [countries, setCountries] = useState<DropdownItem[]>([]);

  useEffect(() => {
    const runAsync = async () => {
      const result = await loadCountriesHandler();
      setCountries(result);
    };
    runAsync();
  }, [loadCountriesHandler]);

  return (
    <Styled.Wrapper>
      <Dropdown
        name={`${fieldName}.overseas.country`}
        label='Country'
        options={countries}
        placeholder='Select'
        {...countryDropDownProps}
      />
      <Styled.AddressContainer mode={mode}>
        {mode === 'Basic' ? (
          <TextArea
            name={`${fieldName}.overseas.info.basic`}
            label='Address'
            hint='Please enter your international address'
            maxLength={300}
            {...fullAddressTextAreaProps}
          />
        ) : (
          <>
            <Styled.InputContainer>
              <TextArea
                name={`${fieldName}.overseas.info.full.fullAddress`}
                mode={'Input'}
                label='Street address'
                hint='Please include unit number if needed'
              />
            </Styled.InputContainer>
            <Styled.InputContainer>
              <Input name={`${fieldName}.overseas.info.full.suburb`} label='City/Town/Suburb' />
            </Styled.InputContainer>
            <Styled.InputContainer>
              <Input
                name={`${fieldName}.overseas.info.full.state`}
                label='State/Region/Province (if applicable)'
              />
            </Styled.InputContainer>
            <Styled.InputContainer>
              <Input
                name={`${fieldName}.overseas.info.full.postCode`}
                label='ZIP/Postcode (if applicable)'
              />
            </Styled.InputContainer>
          </>
        )}
      </Styled.AddressContainer>
    </Styled.Wrapper>
  );
};

export default React.memo(Info, (prevProps, nextProps) => {
  if (
    prevProps.fieldName !== nextProps.fieldName ||
    prevProps.mode !== nextProps.mode ||
    prevProps.loadCountriesHandler !== nextProps.loadCountriesHandler
  ) {
    return false;
  }
  return true;
});
